import { useEffect, useRef } from "react";

/**
 * Subscribes to `window` `resize` with stable add/remove in an effect.
 * Latest `handler` is always used (ref), so callers need not wrap in `useCallback`.
 */
export function useWindowResizeListener(
  handler: (event: UIEvent) => void,
  enabled = true
): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) return undefined;
    const listener: EventListener = ev =>
      handlerRef.current(ev as UIEvent);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [enabled]);
}
